import { render } from "./InfoPEPRepresentante.vue?vue&type=template&id=3a322b49"
import script from "./InfoPEPRepresentante.vue?vue&type=script&lang=js"
export * from "./InfoPEPRepresentante.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AG\\dev\\d_7\\_work\\54\\s\\AEL.DebidaDiligencia.FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__